import { render, staticRenderFns } from "./ModalExibirNoticia.vue?vue&type=template&id=cf9b82be&scoped=true"
import script from "./ModalExibirNoticia.vue?vue&type=script&lang=js"
export * from "./ModalExibirNoticia.vue?vue&type=script&lang=js"
import style0 from "./ModalExibirNoticia.vue?vue&type=style&index=0&id=cf9b82be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9b82be",
  null
  
)

export default component.exports